export const SUCCESS_MESSAGES = {
  CREATE: 'Custom field created successfully',
  UPDATE: 'Custom field updated successfully',
  DELETE: 'Custom field deleted successfully',
};
